"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FaqQuestionsController = /** @class */ (function () {
    function FaqQuestionsController(rootScope, scope, state, faqGroups, selectedSubgroup, searchResults) {
        scope.faqGroups = faqGroups;
        scope.selectedSubgroup = selectedSubgroup;
        scope.searchResults = searchResults;
        scope.isRootVisible = function () {
            return state.current.name !== 'faq.home';
        };
        // send selected subgroup title for faqCtrl after it is resolved
        if (selectedSubgroup.$promise) {
            selectedSubgroup.$promise.then(function (resolvedData) {
                rootScope.$emit('subgroupLoaded', resolvedData.title);
            });
        }
    }
    FaqQuestionsController.prototype.$onInit = function () {
    };
    return FaqQuestionsController;
}());
exports.FaqQuestionsController = FaqQuestionsController;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmFxUXVlc3Rpb25zLmNvbnRyb2xsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmYXFRdWVzdGlvbnMuY29udHJvbGxlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUVBO0lBSUksZ0NBQVksU0FBYyxFQUFFLEtBQVUsRUFBRSxLQUFVLEVBQUUsU0FBYyxFQUFFLGdCQUFxQixFQUFFLGFBQWtCO1FBQ3pHLEtBQUssQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1FBQzVCLEtBQUssQ0FBQyxnQkFBZ0IsR0FBRyxnQkFBZ0IsQ0FBQztRQUMxQyxLQUFLLENBQUMsYUFBYSxHQUFHLGFBQWEsQ0FBQztRQUVwQyxLQUFLLENBQUMsYUFBYSxHQUFHO1lBQ2xCLE9BQU8sS0FBSyxDQUFDLE9BQU8sQ0FBQyxJQUFJLEtBQUssVUFBVSxDQUFDO1FBQzdDLENBQUMsQ0FBQTtRQUVELGdFQUFnRTtRQUNoRSxJQUFJLGdCQUFnQixDQUFDLFFBQVEsRUFBRTtZQUMzQixnQkFBZ0IsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLFVBQUMsWUFBWTtnQkFDeEMsU0FBUyxDQUFDLEtBQUssQ0FBQyxnQkFBZ0IsRUFBRSxZQUFZLENBQUMsS0FBSyxDQUFDLENBQUM7WUFDMUQsQ0FBQyxDQUFDLENBQUM7U0FDTjtJQUNMLENBQUM7SUFsQkQsd0NBQU8sR0FBUDtJQUNBLENBQUM7SUFrQkwsNkJBQUM7QUFBRCxDQUFDLEFBcEJELElBb0JDO0FBcEJZLHdEQUFzQiJ9